import React, { Component } from "react";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { getPaginatedList } from "../../services/baseServices";
import ExportCSVAsync from "../common/ExportCSVAsync";
import { getFormattedDate } from "../../helper/utils";

const headers = [
	{ label: "Route Name", key: "name" },
	{ label: "Phone", key: "phone" },
	{ label: "Total Order", key: "total_order" },
	{ label: "Prepaid", key: "prepaid_order_count" },
	{ label: "Collected by FC", key: "collected_by_fc" },
	{ label: "Collected by SR", key: "collected_by_sr"}
];

const loadData = (item) => {
	return {
		name: item.title,
		phone: item.phone,
		total_order: item.total_order,
		prepaid_order_count: item.prepaid_order_count,
		collected: item.collected,
		collected_by_fc: item.collected_by_fc,
		collected_by_sr: item.collected_by_sr
	};
};

class Routes extends Component {
	constructor() {
		super();
		this.state = {
			routes: [],
			activePage: 1,
			per_page: 15,
			page: 1,
			query_params: {},
			isLoading: true,
		};
	}

	getRouteList = (params) => {
		getPaginatedList("warehouses/routes", params)
			.then((res) => {
				this.setState(
					{
						routes: res.data,
						isLoading: false,
						per_page: res.headers["x-per-page"],
						total_data: parseInt(res.headers["x-total"]),
					},
					() => {}
				);
			})
			.catch((errMsg) => {
				console.log("Error Message: ", errMsg);
			});
	};

	getQueryParams = () => {
		let params = Object.assign(this.state.query_params, {
			per_page: this.state.per_page,
			page: this.state.page,
		});
		return params;
	};

	componentDidMount() {
		console.log(this.props.filteredRiders)
		this.setState({ query_params: this.props.queryParams }, () => {
			this.getRouteList(this.getQueryParams());
		})
	}

	handlePageChange = (pageNumber) => {
		this.setState({ page: pageNumber, activePage: pageNumber }, () => {
			this.getRouteList(this.getQueryParams());
		});
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.queryParams.start_date_time.toString() !== this.props.queryParams.start_date_time.toString() 
            || prevProps.queryParams.end_date_time.toString() !== this.props.queryParams.end_date_time.toString() ) {
			this.setState({ query_params: this.props.queryParams }, () => {
            	this.getRouteList(this.getQueryParams());
			})
        }
	}

	render() {
		return (
		<div className="main-content">
			<div className="page-header">
				<h2 className="page-title">Route List</h2>
				<div className="ml-auto" style={{display: "flex"}}>
					<ExportCSVAsync
					fileName={"Routes-"+getFormattedDate(new Date(),"DD-MM-YYYY")+".csv"}
					Url={`warehouses/routes_export`}
					params={{skip_pagination: true}}
					headers={headers}
					loadData={loadData}
					title="Route List"/>
				</div>
			</div>
			<table className="order-table table table-striped">
				<thead>
					<tr>
						<th style={{ width: '20px' }}>#</th>
						<th>DH Name</th>
						<th>Date</th>
						<th>Route</th>
						<th>Partner</th>
						<th>Sub-Agent</th>
						<th>Order No</th>
					</tr>
				</thead>
				<tbody>
					{this.state.routes.length > 0 ? this.state.routes.map((item, index) => {
					return (
						<tr key={index}>
							<td>{((this.state.page - 1) * this.state.per_page) + index + 1}</td>
							<td>
								<div className="order-item">
								{item?.title}
								</div>
							</td>
							<td>
								<div className="order-item">
								{item?.phone}
								</div>
							</td>
							<td>
								<div className="order-item">
									{item?.total_order}
								</div>
							</td>
							<td>
								<div className="order-item">
									{item?.prepaid_order_count}
								</div>
							</td>
							<td>
								<div className="order-item">
									{item?.collected_by_fc}
								</div>
							</td>
							<td>
								<div className="order-item">
									{item?.collected_by_sr}
								</div>
							</td>
						</tr>
					);
					}) : ""}
				</tbody>
			</table>
			<div className="mt-3">
				<Pagination
					itemClass="page-item"
					linkClass="page-link"
					activePage={this.state.activePage}
					itemsCountPerPage={parseInt(this.state.per_page)}
					totalItemsCount={parseInt(this.state.total_data)}
					pageRangeDisplayed={10}
					onChange={this.handlePageChange.bind(this)}
				/>
			</div>
		</div>
		);
	}

}

export default withRouter(Routes);
